import React, { Fragment } from 'react';
import { NavLink, useParams } from 'react-router';

import { useTranslation } from '~/hooks/useTranslation';

import styles from '../$username.scss';

export default function GalleryTabs({ username }: { username: string }) {
  const { folderId } = useParams<{ folderId?: string }>();
  const { t } = useTranslation();

  const galleryTabs = [
    {
      to: '/gallery/' + username,
      label: t('ImageGallery_Images', 'Images'),
      end: !folderId,
    },
    {
      to: '/gallery/' + username + '/favorites',
      label: t('ImageGallery_Favorites', 'Favorites'),
    },
  ];

  return (
    <div className={styles.GalleryPage__Navigation}>
      {galleryTabs.map(({ to, label, end }, index) => (
        <Fragment key={to}>
          <NavLink
            end={end}
            to={to}
            className={({ isActive }) =>
              isActive
                ? styles.GalleryPage__NavigationLinkActive
                : styles.GalleryPage__NavigationLink
            }
          >
            {label}
          </NavLink>
          {index < galleryTabs.length - 1 && <span>—</span>}
        </Fragment>
      ))}
    </div>
  );
}
